import React from 'react';

import "./index.scss";

export default class Login extends React.Component {
  componentDidMount() {
    PlatformSDK && (PlatformSDK.currentConfig = {
      socialLogin: {
        hideCloseButton: true,
        providers: [
          {
            id: 'github',
            name: 'Github',
            visible: false
          },
          {
            id: 'gplus',
            name: 'Google',
            visible: false
          },
          {
            id: 'facebook',
            name: 'Facebook',
            visible: false
          },
          {
            id: 'webex',
            visible: false
          },
          {
            id: 'ciscosso',
            name: 'a Cisco ID'
          },
          {
            id: 'commonidentity',
            name: 'Cisco Spark',
            visible: false
          },
          {
            id: 'netacad',
            name: 'Cisco NetAcad',
            visible: false
          },
          {
            id: 'linkedin',
            name: 'LinkedIn',
            visible: false
          }
        ]
      }
    });
  
    window.PlatformSDK.openLogin();
  }

  render() {
    return (
      <div className="login-page"></div>
    );
  }
}
